export default {"src":"/_next/static/media/therapy.a3868c5f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};